import styled from "@emotion/styled";
import { colorGuide, colorPalette } from "../../theme/colors";

export const CalendarWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-direction: column;
`;

export const DatePickerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: relative;
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 100px;
  max-height: 160px;
  overflow-y: auto;
  text-align: center;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ScrollItem = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 16px 0px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  color: ${(props) =>
    props.selected
      ? colorGuide.lightComponents.customDatePicker.selected.color
      : colorGuide.lightComponents.customDatePicker.color};
  background: transparent;
  transition: all 0.3s ease;
  min-height: 53px;
  z-index: 2;
`;

export const SelectedHighlight = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  min-height: 53px;
  background: ${colorGuide.lightComponents.customDatePicker.background};
  transform: translateY(-50%);
  border-radius: 4px;
  z-index: 1;
`;
